/**
 * 个人设置静态路由数据
 * */

export default {
  path: '/userSetting',
  name: 'userSetting',
  component: () => import('@/views/index/components/userSetting/index.vue'),
  meta: {
    unrequireLogin: false
  },
  redirect: {
    name: 'companyInfo'
  },
  children: [
    {
      path: '/userSetting/companyInfo',
      name: 'companyInfo',
      component: () => import('@/views/index/components/userSetting/safePrivacy/companyInfo.vue'),
    },
    {
      path: '/userSetting/safe',
      name: 'safe',
      component: () => import('@/views/index/components/userSetting/safePrivacy/safe.vue'),
    }
  ]
}
